<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">ENVOI SMS POUR LA LOGISTIQUE ET LES TRANSPORTS </h1>
    
         
      
        <img
            class="card__image"
            src="/../images/icone_transport-logistique.png"
            alt=""
          />
          <h2>
            Découvrez comment nos solutions servicesms.sn favorisent la réussite des entreprises de logistique et de transport
      </h2>
      <p>
        Dans le secteur de la logistique et du transport, la communication rapide et efficace est essentielle ! Avec servicesms.sn, 
        vous pouvez envoyer des informations en un clic pour obtenir des résultats optimaux.
      </p>
      <p>
        Travaillant avec une clientèle exigeante, l'envoi de SMS vous offre la possibilité de tenir vos clients informés en cas de problème, 
        de changement ou de nouveauté. Notre plateforme d'envoi de SMS automatiques vous permet de gérer au mieux vos relations 
        clients et de construire une relation de confiance et de proximité avec eux.
      </p>
      <p>
        Grâce aux SMS, vous pouvez informer vos clients en cas de retard et leur expliquer les circonstances telles que les accidents,
        le trafic ou les grèves. Cette communication proactive permet à vos clients de gérer leur organisation et vous aide à améliorer
        vos services.
      </p>
      <p>
        Nos solutions digitales vous positionnent en tant qu'entreprise innovante, efficace et transparente dans votre communication.
      </p>
      <p>
        En plus de vos clients, l'envoi de SMS peut être utilisé en interne. Vous pouvez désormais envoyer des SMS à toute votre équipe
        de chauffeurs ou de livreurs pour les informer de l'adresse de livraison, des consignes à suivre ou des dangers routiers.
      </p>
      <p>
        Dans un secteur aussi concurrentiel que le transport, votre entreprise doit se démarquer par sa rapidité et sa réactivité.
        Le SMS, avec sa vitesse et son taux d'ouverture élevé de 95%, est l'outil le plus efficace pour atteindre de tels objectifs.
      </p>
      <p>
        Nos services innovants se distinguent par leur utilité et leur praticité, vous permettant ainsi de transmettre une image irréprochable
         et de qualité.
      </p>
      <h2>
        En voici quelques exemples:
      </h2>
      
<li><strong>Notification de retard de livraison</strong> : Informer les clients en cas de retard de livraison et leur fournir des détails sur les circonstances (trafic, accidents, problèmes logistiques, etc.).<br/></li>
<li><strong>Confirmation de livraison</strong> : Envoyer un SMS pour confirmer la livraison réussie d'une commande, offrant ainsi une tranquillité d'esprit aux clients.</li>
<li><strong>Mises à jour de suivi des colis</strong> : Envoyer des SMS réguliers avec des mises à jour sur l'emplacement et l'état des colis, permettant aux clients de suivre leur livraison en temps réel.<br/></li>
<li><strong>Alertes de disponibilité des produits</strong> : Informer les clients de la disponibilité de produits spécifiques, de promotions ou de réapprovisionnement, favorisant ainsi les ventes et la satisfaction client.<br/></li>
<li><strong>Changements d'itinéraire</strong> : Avertir les chauffeurs ou les livreurs des changements d'itinéraire, des adresses de livraison ou des informations sur les clients, assurant une communication fluide et une exécution précise des livraisons.<br/></li>
<li><strong>Rappels de rendez-vous ou d'échéances</strong> : Envoyer des SMS pour rappeler aux clients les rendez-vous, les retours de marchandises, les échéances de paiement ou les dates limites, facilitant ainsi la planification et la gestion des tâches.<br/></li>
<li><strong>Demandes de confirmation </strong>: Solliciter la confirmation de la disponibilité des clients pour une livraison ou une collecte, réduisant les erreurs et les inefficacités dans les opérations logistiques.</li>

      <h2>Exemples de campagnes SMS :</h2>
     
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/transport-log1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/transport-log2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/transport-log3.png" />
        </div>
      </div>
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
